module.exports = __webpack_public_path__ + "static/sec12-bg-sm-61bd809f627c749beeb581ba7328a132.jpg";